import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';

import initMenu from './components/menu';
import initCookies from './components/cookies';

import initSplash from './components/splash';
import initAboutHero from './components/about-hero';
import initHomeHero from './components/home-hero';
import initHomeGallery from './components/home-gallery';
import initPaintReveals from './components/paint-reveal';
import initVideoEmbed from './components/video-embed';

initCookies();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menu = document.querySelector('.js-menu');

if (menu) {
    initMenu(menu);
}

// const splash = document.querySelector('.js-splash');

// if (splash) {
//     initSplash(splash);
// }

const homeHero = document.querySelector('.js-home-hero');

if (homeHero) {
    initHomeHero(homeHero);
}

const homeGallery = document.querySelector('.js-home-gallery');

if (homeGallery) {
    initHomeGallery(homeGallery);
}

const aboutHero = document.querySelector('.js-about-hero');

if (aboutHero) {
    initAboutHero(aboutHero);
}

const paintReveals = document.querySelectorAll('.js-paint-reveal');

if (paintReveals && paintReveals.length > 0) {
    initPaintReveals(paintReveals);
}

const videoEmbedEls = document.querySelectorAll('.js-video-embed');

if (videoEmbedEls && videoEmbedEls.length > 0) {
    initVideoEmbed(videoEmbedEls);
}
